import { useState } from "react";
import { Box, Typography, Checkbox, FormControlLabel, Link } from "@mui/material";

const TermsAgreement = ({ marketingConsent, setMarketingConsent, termsAccpt,
    setTermsAccpt }) => {



    const classes = {
        anchorLink: {
            textDecoration: "none",
            color: "#1976d2",
            fontWeight: 500,
            "&:hover": {
                textDecoration: "underline",
            },
        },
        sectionBox: {
            mt: 2,
            p: 0,
            borderRadius: 1,
            backgroundColor: "#fafafa",
            border: "1px solid #e0e0e0",
        },
        linksPara: {
            fontSize: "0.9rem",
            color: "#555",
            lineHeight: 1.6,
        },
    };

    return (
        <Box sx={classes.sectionBox}>

            <Box mt={1}>
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={termsAccpt}
                            onChange={(e) => setTermsAccpt(e.target.checked)}
                            color="primary"
                        />
                    }
                    label={
                        <Typography sx={{ fontSize: "0.85rem", color: "#444" }}>
                            I agree to the <Link href="#" underline="hover" sx={classes.anchorLink}>
                                Terms of Service
                            </Link> & <Link href="#" underline="hover" sx={classes.anchorLink}>
                                Privacy Policy
                            </Link>
                        </Typography>
                    }
                />

                <FormControlLabel
                    control={
                        <Checkbox
                            checked={marketingConsent}
                            onChange={(e) => setMarketingConsent(e.target.checked)}
                            color="primary"
                        />
                    }
                    label={
                        <Typography sx={{ fontSize: "0.85rem", color: "#444" }}>
                            I consent to receive marketing communications
                        </Typography>
                    }
                />
            </Box>
        </Box>
    );
};

export default TermsAgreement;
